import { css } from '@emotion/css';

export const popupButtonAdornmentStyles = css`
  .MuiButton-startIcon {
    margin-inline-end: 0.6rem;
    margin-inline-start: -0.2rem;
  }

  .MuiButton-endIcon {
    margin-inline-start: 0.2rem;
  }
`;

export const popupButtonFocusStyles = css`
  &.Mui-focusVisible {
    box-shadow:
      0 0 0 0.1rem var(--bg-hover),
      0 0 0 0.3rem var(--focus-secondary);
  }
`;
